import { mapV1UpdateClientRequestToV2 } from './v1-to-v2'
import { mapV2ClientToUiClient } from './v2-to-ui'
import { mapV2ClientReserveRateHistory } from './v2-to-v1'

/**
 * @typedef {import('../../../api-v2/js-doc').V1ReserveRateHistoryResponse} V1ReserveRateHistoryResponse
 * @typedef {import('../../../api-v2/js-doc').V1ReserveTotalResponse} V1ReserveTotalResponse
 * @typedef {import('../../../api-v2/js-doc').V1UpdateClientRequest} V1UpdateClientRequest
 * @typedef {import('../../../api-v2/js-doc').V2ClientReserveRateHistory} V2ClientReserveRateHistory
 * @typedef {import('../../../api-v2/js-doc').V2ReserveTotalResponse} V2ReserveTotalResponse
 * @typedef {import('../../../api-v2/js-doc').V2MappingOptions} V2MappingOptions
 * @typedef {import('../../../api-v2/js-doc').V2ClientFactoringConfigResponse} V2ClientFactoringConfigResponse
 * @typedef {import('../../../api-v2/js-doc').V2UpdateClientFactoringConfigRequest} V2UpdateClientFactoringConfigRequest
 * @typedef {import('../../../api-v2/js-doc').V2ClientResponse} V2ClientResponse
 * @typedef {import('../../../api-v2/js-doc').UiClientModel} UiClientModel
 */
export class ClientMapper {
  /**
   * @param {V2ClientReserveRateHistory} v2History - V2 reserve rate history
   * @returns {V1ReserveRateHistoryResponse}
   */
  static v2ReserveRateHistoryToV1 (v2History) {
    return mapV2ClientReserveRateHistory(v2History)
  }

  /**
   * @param {V2ReserveTotalResponse} v2ReserveTotalResponse - V2 reserve total response
   * @returns {V1ReserveTotalResponse}
   */
  static v2ReserveTotalToV1 (v2ReserveTotalResponse) {
    return {
      total: v2ReserveTotalResponse.amount,
    }
  }

  /**
   * @param {V2MappingOptions} v2MappingOptions - V2 mapping options
   * @param {V1UpdateClientRequest} v1Request - V1 create invoice request body
   * @returns {V2UpdateClientFactoringConfigRequest} - V2 create invoice request body
   */
  static v1UpdateClientRequestToV2 (v2MappingOptions, v1Request) {
    return mapV1UpdateClientRequestToV2(v2MappingOptions, v1Request)
  }

  /**
   * @param {V2ClientResponse} client - V2 Client
   * @returns {UiClientModel}
   */
  static v2ClientToUI (client) {
    return mapV2ClientToUiClient(client)
  }
}
  
